import { Typography } from '@jouzen/ecom-components/v3/Typography';

import RichText from '@/app/components/RichText';

import type { AccuracyCardProps } from './AccuracyCard';

const MobileAccuracyCard = ({
  heading,
  icon: Icon,
  note,
  percentage,
}: AccuracyCardProps) => {
  return (
    <div
      className="flex flex-col items-center gap-y-4 border-b-2 border-b-gray-300 py-9 text-gray-400 last:border-0"
      data-cy="mobile-accuracy-card"
    >
      <div className="size-6 text-sandstone-500">
        <Icon width={24} height={24} />
      </div>
      <Typography className="text-heading-2xl" font="serif" weight="thin">
        {percentage.toLocaleString(undefined, { style: 'percent' })}
      </Typography>
      <Typography variant="body-large" color="dark">
        <RichText messageKey={heading} />
      </Typography>
      {note && (
        <Typography color="inherit" variant="body-small">
          <RichText messageKey={note} />
        </Typography>
      )}
    </div>
  );
};

export default MobileAccuracyCard;
